import { createSelector } from 'reselect';
import { getWorkOrderOperationProgress } from './getWorkOrderOperationProgress';

export const getWorkOrderOpBadParts = createSelector(
  [getWorkOrderOperationProgress],
  ({ workOrderOpBadParts }) => {
    return workOrderOpBadParts;
  }
);
